import { Quote } from "lucide-react";
import { Reveal, scrollToId } from "@/components/Reveal";
import Sparkle from "@/components/Sparkle";

export default function Reviews() {
  return (
    <section id="reviews" data-testid="reviews-section" className="bg-blush px-5 py-24 sm:px-8 lg:py-32">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <span className="eyebrow text-espresso/50">Kind words</span>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-5 max-w-2xl font-display text-4xl sm:text-5xl lg:text-6xl">
            The reviews are <em className="italic text-rose">on the house</em>
          </h2>
        </Reveal>

        <Reveal delay={0.2}>
          <div
            data-testid="reviews-placeholder"
            className="mt-12 flex flex-col items-center rounded-3xl border border-dashed border-espresso/25 bg-white/60 px-8 py-16 text-center"
          >
            <span className="flex h-14 w-14 items-center justify-center rounded-full bg-espresso text-gold">
              <Quote className="h-6 w-6" />
            </span>
            <p className="mt-8 max-w-xl font-display text-2xl leading-snug text-espresso sm:text-3xl">
              Your event could be our first <em className="italic text-rose">five stars</em>.
            </p>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-espresso/60">
              We're a fresh pour on the San Antonio scene — real client quotes land right
              here as soon as our couples and hosts share them.
            </p>
            <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
              <button
                data-testid="reviews-book-cta"
                onClick={() => scrollToId("book")}
                className="rounded-full bg-espresso px-7 py-3 text-sm font-semibold uppercase tracking-[0.16em] text-cream transition-transform duration-300 hover:scale-105"
              >
                Book your date
              </button>
              <a
                href="https://www.instagram.com/TheShakenSociety"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="reviews-instagram-link"
                className="inline-flex items-center gap-2 rounded-full border border-espresso/25 px-7 py-3 text-sm font-semibold uppercase tracking-[0.16em] text-espresso transition-colors duration-300 hover:border-gold"
              >
                <Sparkle className="h-3.5 w-3.5" />
                Follow the pours
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}